import * as React from 'react';
import { motion } from 'motion/react';
import { getVariants, useAnimateIconContext, IconWrapper } from './AnimateIcon';

const animations = {
  default: {
    plane: {},
  },
  send: {
    plane: {
      initial: { x: 0, y: 0, opacity: 1 },
      animate: {
        x:       [0,  40, -24,  0],
        y:       [0, -40,  24,  0],
        opacity: [1,   0,   0,  1],
        transition: {
          duration: 0.9,
          times: [0, 0.38, 0.55, 1],
          ease: 'easeInOut',
        },
      },
    },
  },
};

function IconComponent({ size, ...props }) {
  const { controls } = useAnimateIconContext();
  const variants = getVariants(animations);

  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <motion.g variants={variants.plane} initial="initial" animate={controls}>
        <path d="M22 2 11 13" />
        <path d="M22 2 15 22 11 13 2 9 22 2z" />
      </motion.g>
    </motion.svg>
  );
}

function Send(props) {
  return <IconWrapper icon={IconComponent} {...props} />;
}

export { animations, Send, Send as SendIcon };
